export const FALLBACK_LANGUAGE = "en"

export const getBrowserLanguage = (): string => {
  if (navigator.languages && navigator.languages[0]) {
    return navigator.languages[0]
  }
  if (navigator.language) {
    return navigator.language
  }
  return FALLBACK_LANGUAGE
}
